import React from "react";
import { Helmet } from "react-helmet";

/**
 * Reusable SEO component for managing meta tags
 *
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - Meta description
 * @param {string} props.canonicalUrl - Canonical URL
 * @param {string} props.imageUrl - OG image URL
 * @param {string} props.type - OG type (default: website)
 * @param {Object} props.schema - JSON-LD Schema data
 */
const SEOHead = ({
  title = "MyBurgo - Parenting App | Pregnancy App | SelfCare App",
  description = "MyBurgo is India's comprehensive parenting app offering expert guidance, interactive workshops, personalized resources, and community support for parents and pregnant women. Empower your parenting journey with child development tools, curated recipes, mental health support, and more.",
  canonicalUrl,
  imageUrl = "https://myburgo.com/logo.png",
  type = "website",
  schema,
}) => {
  const currentUrl =
    canonicalUrl || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      {imageUrl && <meta property="og:image" content={imageUrl} />}

      {/* Twitter Card Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}

      {/* JSON-LD Schema */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEOHead;
